import Vue from 'vue';
import { SmartSuggestV4 } from '../../../../declarations/request';

export enum ShowAllResultsPositions {
    off = 'off',
    full = 'full',
    product = 'product',
}

const showAllResults = Vue.component('fl-show-all-results', {
    template: `
    <div class="fl-as-show-all-results fl-w-100">
    <h3 class="fl-background fl-text-center fl-w-100 fl-align-end fl-as-show-all-results-text" @click="submit()"
        v-html="allResultsText">
    </h3>
    </div>`,
    inject: ['HandleInteractionService', 'config', 'requestService', 'HandleShopInteractionService', 'utils'],
    computed: {
        allResultsText(): string {
            const label = !this.HandleShopInteractionService.getActiveInputValue().trim()
                ? this.config.assistedSuggest.text.showAllResultsLabelEmptyQuery
                : this.config.assistedSuggest.text.showAllResultsLabel;
            const queryText = this.utils.escapeUserProvidedText(
                this.showOriginalQueryInsteadOfSuggested ? this.$data.originalQuery : this.$data.suggestionQuery
            );

            return label
                .replace('%query%', `<span class="fl-submit-text-query">${queryText}</span>`)
                .replace('%count%', `<span class="fl-submit-text-count">${this.$data.totalResults}</span>`);
        },
        showOriginalQueryInsteadOfSuggested(): boolean {
            return this.suggestionQuery === '' && this.totalResults > 0;
        },
    },
    methods: {
        submit(): void {
            this.HandleInteractionService.byQuery(this.$data.suggestionQuery).submit();
        },
    },
    data(): Record<string, any> {
        return {
            suggestionQuery: '',
            totalResults: 0,
            originalQuery: '',
        };
    },
    mounted(): void {
        this.requestService.onResultChange((result: SmartSuggestV4.Response) => {
            this.$data.suggestionQuery = result.effectiveProductSuggestionQuery;
            this.$data.totalResults = result.totalResults;
            this.$data.originalQuery = this.HandleShopInteractionService.getActiveInputValue();
        });
    },
});

export default showAllResults;
